import script from "./WifiWindow.vue?vue&type=script&setup=true&lang=ts"
export * from "./WifiWindow.vue?vue&type=script&setup=true&lang=ts"

import "./WifiWindow.vue?vue&type=style&index=0&id=2d8b171b&scoped=true&lang=css"

import exportComponent from "/Users/ra1to/Desktop/web_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2d8b171b"]])

export default __exports__